"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tokenizer = exports.parseContentRange = void 0;
const range_request_factory_1 = require("./range-request-factory");
var range_request_tokenizer_1 = require("./range-request-tokenizer");
Object.defineProperty(exports, "parseContentRange", { enumerable: true, get: function () { return range_request_tokenizer_1.parseContentRange; } });
/**
 * Construct range-tokenizer from range-request-client and config
 * @param rangeRequestClient - HTTP range request client
 * @param config - Configuration
 * @return Tokenizer
 */
function tokenizer(rangeRequestClient, config) {
    const factory = new range_request_factory_1.RangeRequestFactory(rangeRequestClient);
    return factory.initTokenizer(config);
}
exports.tokenizer = tokenizer;
//# sourceMappingURL=index.js.map